
        <div class="form-group product__option"  fxLayout="row" fxLayoutAlign="center center" >
            <div class="form-group" fxLayout="column" fxLayoutAlign="space-around center">
                <dp-time-select
                #dateComponent
                (onChange)="log($event)"
                (onSelect)="onSelect($event)"
                [(ngModel)]="selected"
                [config]="config"
                [minDate]="this.availableFrom"
                [maxDate]="this.availableTo"
                theme="dp-material"></dp-time-select>

            </div>

        </div>
